import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/lib/util/colors';
import { SEMANTIC_LIGHT } from '@/theme/tokens.js';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        // The canvas token (src/theme/tokens.js), shared with Tailwind.
        background: SEMANTIC_LIGHT.canvas,
        primary: colors.amber.darken4,
      },
    },
  },
};

export default new Vuetify(opts);
